export type MessageType = 'default' | 'product' | 'sourcedBy';

export const messageTabOptions: { label: string; value: MessageType }[] = [
  { label: 'Send Message', value: 'default' },
  { label: 'Backend Hours', value: 'product' },
  { label: 'Sourced By', value: 'sourcedBy' },
];
